/**
 * The environments the Versions page draws a card for (PSTUDIO-4780). The
 * backend also reports older environments a solution was once published to;
 * they are no longer used, so their cards are only clutter. This list decides
 * which cards are drawn and nothing else: no version or deployment record is
 * changed, and the Published Versions table keeps every row.
 */
export const CARD_ENVIRONMENTS: readonly string[] = [
  'draft',
  'sandbox',
  'live',
];

/**
 * Keeps the `[env, version]` entries whose environment is one of
 * {@link CARD_ENVIRONMENTS}, in the order given. The name is compared
 * case-insensitively, as the table's active-environment highlight does, and
 * otherwise exactly: padding is not trimmed, and a name that only contains a
 * kept one (`live-old`) does not match. This is a limitation, not a promise
 * about the rest of the page: the card's own version lookup in `versions.tsx`
 * compares the name as given, so a `Live` that passes here still gets a blank
 * card, as it did before this filter existed.
 */
export const filterEnvironmentCards = <T extends [string, ...unknown[]]>(
  entries: T[]
): T[] =>
  entries.filter(([env]) => CARD_ENVIRONMENTS.includes(env.toLowerCase()));
